module.exports = __webpack_public_path__ + "img/bistecca_en.862bb833.png";